interface TableData {
  value: string | number;
  colspan?: number;
  align?: 'left' | 'center' | 'right' | 'justify' | 'char';
  className?: string;
}

interface TableInterface {
  headers: Array<TableData>;
  rows: Array<{
    data: Array<TableData>;
  }>;

  tableClass?: Array<string>;
}

export const Table = ({
  headers,
  rows,
  tableClass,
}: TableInterface): JSX.Element => {
  return (
    <table
      className={`w-full border-collapse border border-grey-300 ${tableClass}`}
    >
      <thead>
        <tr>
          {headers?.map((column: TableData) => (
            <th
              className={`border border-grey-300 border-r-0 border-l-0 px-5 py-4 sm:text-s-14 sm:p-2 ${column.className}`}
              colSpan={column.colspan}
              key={column.value}
            >
              {column.value}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows?.map((row, rowIndex: number) => (
          <tr key={`row_${rowIndex}`}>
            {row.data.map((col: TableData, colIndex) => (
              <td
                className={`border border-grey-300 border-r-0 border-l-0 p-4 sm:text-s-14 sm:p-2 ${col.className}`}
                key={`col_${rowIndex}_${colIndex}`}
                align={col.align}
                colSpan={col.colspan}
              >
                {col.value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
